import { useState } from 'react';
import { useFaultsQuery } from '../api/faults';
import { useAckFaultMutation } from '../api/mutations';
import { BackLink } from '../components/layout/BackLink';
import { FaultsList } from '../components/faults/FaultsList';

export function FaultsPage() {
  const [includeCleared, setIncludeCleared] = useState(false);
  const q = useFaultsQuery(includeCleared);
  const ack = useAckFaultMutation();
  const onAcknowledge = (id: string) => ack.mutate(id);
  const ackingId = ack.isPending ? (ack.variables as string) : null;

  return (
    <>
      <BackLink />
      <h1>Faults</h1>
      <div className="card" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <label>
          <input
            type="checkbox"
            checked={includeCleared}
            onChange={(e) => setIncludeCleared(e.target.checked)}
          />{' '}
          include cleared
        </label>
        {q.isFetching && <span className="muted">refreshing…</span>}
      </div>
      <h2>{includeCleared ? 'All faults' : 'Active faults'}</h2>
      {q.isLoading && <div className="skeleton" style={{ height: 100 }} />}
      {q.isError && <div className="banner danger">{(q.error as Error).message}</div>}
      {q.data && <FaultsList rows={q.data} onAcknowledge={onAcknowledge} ackingId={ackingId} />}
      {ack.isError && <div className="banner danger">{(ack.error as Error).message}</div>}
    </>
  );
}
